/* PawLi reviews — play a review video inline (in place) with sound, no popup. */
(function () {
  document.addEventListener('click', (e) => {
    const wrap = e.target.closest('[data-pawli-rvideo]');
    if (!wrap) return;
    const v = wrap.querySelector('video');
    if (!v) return;
    if (v.paused) {
      // pause any other review video that is playing
      document.querySelectorAll('[data-pawli-rvideo].is-playing video').forEach((o) => {
        if (o !== v) { o.pause(); o.closest('[data-pawli-rvideo]').classList.remove('is-playing'); }
      });
      v.muted = false;
      v.controls = true;
      wrap.classList.add('is-playing');
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    } else {
      v.pause();
    }
  });
  // when a video is paused via its native controls, bring the play overlay back
  document.addEventListener('pause', (e) => {
    const v = e.target;
    if (v.tagName !== 'VIDEO') return;
    const wrap = v.closest('[data-pawli-rvideo]');
    if (wrap && v.currentTime < v.duration) wrap.classList.remove('is-playing');
  }, true);
})();
